import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { colors, type, spacing, radius } from "@/theme";
import { CONTACT } from "@/content/site";
import SiteFooter from "@/components/SiteFooter";

const steps = [
  "Accedi al backoffice con email e password del tuo locale.",
  'Apri Impostazioni e scorri fino a "Zona pericolosa".',
  'Tocca "Elimina il mio account" e conferma con la password.',
];

export default function EliminaAccount() {
  const navigate = useNavigate();
  useEffect(() => { document.title = "Eliminare l'account | Tavoline"; }, []);
  return (
    <div style={{ minHeight: "100vh", background: colors.paper }}>
      <div style={{ width: "100%", maxWidth: 680, margin: "0 auto", padding: `${spacing.xl}px ${spacing.lg}px`, display: "flex", flexDirection: "column", gap: spacing.md }}>
        <h1 style={{ ...type.serif, fontSize: 36, lineHeight: "40px", color: colors.ink, margin: 0 }}>Eliminare l'account Tavoline</h1>
        <p style={body}>Puoi eliminare il tuo account in qualsiasi momento, direttamente dall'app o dal sito:</p>
        {steps.map((s, i) => <p key={i} style={body}>{i + 1}. {s}</p>)}
        <button data-testid="delete-go-login" onClick={() => navigate("/staff/login")} style={{ ...type.sansSemi, fontSize: 16, color: colors.onAccent, background: colors.accent, border: "none", minHeight: 52, borderRadius: radius.md, padding: `0 ${spacing.lg}px`, alignSelf: "flex-start" }}>
          Vai all'accesso
        </button>
        <h2 style={h2}>Cosa viene eliminato</h2>
        <p style={body}>Account, dati del locale, menu, piatti e foto, tavoli, ordini e statistiche. La cancellazione è immediata e definitiva: non conserviamo copie dei tuoi dati dopo l'eliminazione.</p>
        <h2 style={h2}>Non riesci ad accedere?</h2>
        <p style={body}>Scrivi dall'indirizzo email con cui ti sei registrato e indica il nome del locale: eliminiamo l'account entro 30 giorni.</p>
        <a data-testid="delete-email" href={`mailto:${CONTACT.email}?subject=Eliminazione%20account%20Tavoline`} style={{ ...type.sansSemi, fontSize: 16, color: colors.ink, textDecoration: "underline" }}>{CONTACT.email}</a>
        <SiteFooter />
      </div>
    </div>
  );
}

const body = { ...type.sans, fontSize: 16, lineHeight: "26px", color: colors.ink, margin: 0 };
const h2 = { fontFamily: '"Instrument Serif", Georgia, serif', fontWeight: 400, fontSize: 26, color: colors.ink, marginTop: spacing.md, marginBottom: 0 };
